// import React, { useEffect, useMemo, useState } from 'react';
// import { CometChat } from '@cometchat/chat-sdk-javascript';
// import { ArrowLeft, Camera } from 'lucide-react';
// import { DarkModeSwitch } from 'react-toggle-dark-mode';
// import '../../styles/CometChatSelector/CometChatUserProfileModal.css';

// import { COMETCHAT_CONSTANTS } from "../../../index";
// import { useCometChatContext } from 'CometChat/context/CometChatContext';
// import useSystemColorScheme from 'CometChat/customHooks';

// interface Props {
//     user: CometChat.User;
//     onClose: () => void;
//     onUpdated: (user: CometChat.User) => void;
// }
// interface UserMetadata {
//     '@private'?: {
//         email?: string;
//     };
// }

// const IMGBB_API_KEY = 'e4024eeb4e56703dccfca59fee110749';

// interface Friend {
//     uid: string;
//     name: string;
//     avatar: string;
//     status?: string;
//     role?: string;
//     lastActiveAt?: number;
// }

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const CometChatUserProfileModal = ({ user, onClose, onUpdated }: Props) => {
//     const [name, setName] = useState(user.getName());
//     const [avatar, setAvatar] = useState<string>(user.getAvatar() || '');
//     const [uploading, setUploading] = useState(false);
//     const [friendsList, setFriendsList] = useState<Friend[]>([]);
//     // const [backingUp, setBackingUp] = useState(false);

//     const { styleFeatures, setStyleFeatures } = useCometChatContext();
//     console.log("styleFeatures->", styleFeatures);

//     let colorScheme = "light";
//     // Resolve final theme considering user preference and system
//     const theme = useMemo(() => {
//         if (!styleFeatures) return colorScheme; // default light
//         if (styleFeatures.theme === "system") return colorScheme; // use system preference
//         return styleFeatures.theme;
//     }, [styleFeatures?.theme, colorScheme]);

//     colorScheme = useSystemColorScheme();
//     // Apply theme to document for CSS
//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', theme);
//     }, [theme]);

//     const [notificationsEnabled, setNotificationsEnabled] = useState<boolean>(false);

//     useEffect(() => {
//         fetchNotifications();
//     }, [user]);

//     const fetchNotifications = async () => {
//         try {
//             const response = await fetch(`${API_BASE_URL}/notifications?user_id=${user.getUid()}`);
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }
//             const data = await response.json();
//             console.log("Notification API response:", data);

//             // Convert string to real boolean safely
//             const soundNotifRaw = data["Sound Notifications"];
//             const soundNotifBool = soundNotifRaw === true || soundNotifRaw === "true";

//             localStorage.setItem(
//                 `chat_notifications_${user.getUid()}`,
//                 JSON.stringify(soundNotifBool) // value is boolean
//             );

//             setNotificationsEnabled(Boolean(soundNotifBool)); // ensure it's boolean

//         } catch (error) {
//             console.error("Failed to fetch notification:", error);
//             setNotificationsEnabled(false);
//         }
//     };

//     const updateNotification = async (value: boolean) => {
//         try {
//             // Call your Python API to update Airtable
//             const response = await fetch(`${API_BASE_URL}/notifications/update`, {
//                 method: "PUT",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     user_id: user.getUid(),
//                     sound_notifications: value
//                 }),
//             });

//             if (!response.ok) {
//                 throw new Error(`Failed to update: ${response.status}`);
//             }

//             const data = await response.json();
//             console.log("Notification updated:", data);

//             // Re-fetch notifications to ensure state is synced
//             await fetchNotifications();

//         } catch (error) {
//             console.error("Error updating notification:", error);
//             alert("Failed to update notification");
//         }
//     };

//     /** Load existing friends */
//     useEffect(() => {
//         const fetchFriends = async () => {
//             try {
//                 const res = await fetch(
//                     `${COMETCHAT_CONSTANTS.API_URL}/users/${user.getUid()}/friends?perPage=100&page=1`,
//                     {
//                         headers: {
//                             'apikey': COMETCHAT_CONSTANTS.REST_API_KEY, // secure: should ideally be called from backend
//                         },
//                     }
//                 );
//                 const data = await res.json();
//                 const friends: Friend[] = data.data.map((f: any) => ({
//                     uid: f.uid,
//                     name: f.name,
//                     avatar: f.avatar ? f.avatar.replace(/\\/g, '') : `https://ui-avatars.com/api/?name=${encodeURIComponent(f.name)}`,
//                     status: f.status,
//                     role: f.role,
//                     lastActiveAt: f.lastActiveAt
//                 }));

//                 setFriendsList(friends);
//             } catch (err) {
//                 console.error('Failed to fetch friends', err);
//             }
//         };
//         fetchFriends();
//     }, [user]);

//     /** ImgBB upload */
//     const uploadAvatarToImgBB = async (file: File): Promise<string> => {
//         const formData = new FormData();
//         formData.append('image', file);

//         const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
//             method: 'POST',
//             body: formData,
//         });

//         const data = await response.json();
//         if (!data.success) throw new Error(data.error?.message || 'Upload failed');
//         return data.data.url;
//     };

//     const onAvatarChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//         const file = e.target.files?.[0];
//         if (!file) return;

//         if (file.size > 2 * 1024 * 1024) {
//             alert('Image must be smaller than 2MB');
//             return;
//         }

//         try {
//             setUploading(true);
//             const imageUrl = await uploadAvatarToImgBB(file);
//             setAvatar(imageUrl);
//         } catch (err) {
//             console.error('Avatar upload failed', err);
//             alert('Failed to upload image');
//         } finally {
//             setUploading(false);
//         }
//     };

//     /** Save profile */
//     const handleSave = async () => {
//         try {
//             user.setName(name);
//             user.setAvatar(avatar);

//             const updatedUser = await CometChat.updateCurrentUserDetails(user);
//             onUpdated(updatedUser);
//             onClose();
//         } catch (err) {
//             console.error('Profile update failed', err);
//             alert('Failed to update profile');
//         }
//     };

//     /** 🔥 BACKUP NOW */
//     // const handleBackupNow = async () => {
//     //     try {
//     //         setBackingUp(true);
//     //         const res = await fetch('http://localhost:5000/api/backup-now', {
//     //             method: 'POST',
//     //             headers: { 'Content-Type': 'application/json' },
//     //             body: JSON.stringify({
//     //                 userId: user.getUid(),
//     //                 // days: null // or 30
//     //             })
//     //         });

//     //         const data = await res.json();
//     //         if (!res.ok) throw new Error(data.detail);

//     //         alert(`Backup complete!\n${data.oneDriveLink}`);
//     //     } catch (err: any) {
//     //         alert(err.message || 'Backup failed');
//     //     } finally {
//     //         setBackingUp(false);
//     //     }
//     // };

//     // Toggle function
//     const handleThemeToggle = () => {
//         // Determine the current applied theme
//         const currentTheme = styleFeatures?.theme === 'system' ? colorScheme : styleFeatures?.theme;

//         // Toggle manually
//         const newTheme = currentTheme === 'light' ? 'dark' : 'light';

//         // Save to context
//         setStyleFeatures(prev => ({ ...prev, theme: newTheme }));

//         // Persist in local storage
//         localStorage.setItem(`chat_theme_${user.getUid()}`, newTheme);
//     };

//     return (
//         <div className="profile-overlay">
//             <div className="profile-modal">
//                 {/* Header */}
//                 <div className="profile-header">
//                     <ArrowLeft size={24} strokeWidth={2} onClick={onClose} className="back-icon" />
//                     <h3>Profile</h3>
//                 </div>

//                 {/* Profile Info (centered) */}
//                 <div className="profile-main">
//                     <div className="avatar-wrapper">
//                         <img
//                             className="avatar-img"
//                             src={avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}`}
//                             alt="avatar"
//                         />
//                         <div className="avatar-edit" onClick={() => document.getElementById('avatar-upload')?.click()}>
//                             {uploading ? 'Uploading...' : <Camera size={20} />}
//                         </div>
//                         <input type="file" accept="image/*" hidden id="avatar-upload" onChange={onAvatarChange} />
//                     </div>

//                     <input
//                         className="profile-name"
//                         value={name}
//                         onChange={e => setName(e.target.value)}
//                         placeholder="Name"
//                     />

//                     <div className="profile-role-lastActive">
//                         {/* <div><strong>Role:</strong> {user.getRole()}</div> */}
//                         <div><strong>Role:</strong> {user.getRole().toLowerCase() === "manager"
//                             ? "RA"
//                             : user.getRole().charAt(0).toUpperCase() + user.getRole().slice(1)
//                         }</div>
//                         <div><strong>Email:</strong> {(user.getMetadata() as UserMetadata)?.['@private']?.email}</div>
//                         {/* <div><strong>Last Active:</strong> {new Date(user.getLastActiveAt() * 1000).toLocaleString()}</div> */}
//                         <div>
//                             <strong>Last Active:</strong>{' '}
//                             {typeof user.getLastActiveAt === 'function' && user.getLastActiveAt() > 0
//                                 ? new Date(user.getLastActiveAt() * 1000).toLocaleString()
//                                 : 'You have logged in for the first time'}
//                         </div>
//                     </div>

//                     <div className="profile-buttons">
//                         <button className="profile-save-btn" onClick={handleSave} disabled={uploading}>
//                             Save
//                         </button>
//                         {/* <button onClick={handleBackupNow} disabled={backingUp}>
//                             <Download size={16} />
//                             {backingUp ? 'Backing up...' : 'Backup Now'}
//                         </button> */}
//                     </div>
//                 </div>

//                 {/* Friends List below */}
//                 {user.getRole() !== "manager" && <div className="friends-section">
//                     <h3>{"RA Assign"}</h3>
//                     {friendsList.length === 0 ? (
//                         <p className="no-friends-text">{user.getRole() === "manager" ? "No contacts found." : "No manager assigned"}</p>
//                     ) : (
//                         <ul className="friends-list">
//                             {friendsList.map(f => (
//                                 <li key={f.uid} className="friend-item">
//                                     <img src={f.avatar} alt={f.name} className="friend-avatar" />
//                                     <span className="friend-name">{f.name}</span>
//                                 </li>
//                             ))}
//                         </ul>
//                     )}
//                 </div>}
//                 <div className="wa-toggle-container">
//                     <span className="wa-toggle-label">Sound Notifications</span>
//                     <label className="wa-switch">
//                         <input
//                             type="checkbox"
//                             checked={notificationsEnabled}
//                             onChange={async (e) => {
//                                 const value = e.target.checked;
//                                 setNotificationsEnabled(value);
//                                 localStorage.setItem(
//                                     `chat_notifications_${user.getUid()}`,
//                                     JSON.stringify(value)
//                                 );
//                                 // Call API to update Airtable and refresh state
//                                 await updateNotification(value);
//                             }}
//                         />
//                         <span className="wa-slider"></span>
//                     </label>
//                 </div>
//                 <div className="wa-toggle-container">
//                     <span className="wa-toggle-label">Theme</span>
//                     <DarkModeSwitch
//                         checked={theme === 'dark'}
//                         onChange={handleThemeToggle}
//                         size={24}
//                         sunColor={theme === 'dark' ? 'white' : 'black'}
//                         moonColor={theme === 'dark' ? 'white' : 'black'}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CometChatUserProfileModal;

import React, { useEffect, useMemo, useState } from 'react';
import { CometChat } from '@cometchat/chat-sdk-javascript';
import { ArrowLeft, Camera } from 'lucide-react';
import '../../styles/CometChatSelector/CometChatUserProfileModal.css';

import { COMETCHAT_CONSTANTS } from "../../../index";
import { useCometChatContext } from 'CometChat/context/CometChatContext';
import useSystemColorScheme from 'CometChat/customHooks';
import { overrideAudio } from "CometChat/utils/audioControl";

interface Props {
    user: CometChat.User;
    onClose: () => void;
    onUpdated: (user: CometChat.User) => void;
}

interface UserMetadata {
    '@private'?: {
        email?: string;
        email_notifications?: boolean | string;
    };
}

const IMGBB_API_KEY = 'e4024eeb4e56703dccfca59fee110749';

interface Friend {
    uid: string;
    name: string;
    avatar: string;
    status?: string;
    role?: string;
    lastActiveAt?: number;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CometChatUserProfileModal = ({ user, onClose, onUpdated }: Props) => {

    const [name, setName] = useState(user.getName());
    const [avatar, setAvatar] = useState<string>(user.getAvatar() || '');
    const [uploading, setUploading] = useState(false);
    const [friendsList, setFriendsList] = useState<Friend[]>([]);
    const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState<boolean>(false);

    const { styleFeatures, setStyleFeatures } = useCometChatContext();

    /* ✅ System Theme */
    const systemTheme = useSystemColorScheme();

    /* ✅ Final Theme (Light / Dark / System) */
    const theme = useMemo(() => {
        if (!styleFeatures?.theme || styleFeatures.theme === "system") {
            return systemTheme;
        }
        return styleFeatures.theme;
    }, [styleFeatures?.theme, systemTheme]);

    /* Apply theme */
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    useEffect(() => {
        const metadata = (user.getMetadata() || {}) as UserMetadata;

        const emailNotifRaw = metadata['@private']?.email_notifications;

        // ✅ DEFAULT TRUE if not present
        const emailNotif =
            emailNotifRaw === undefined
                ? true
                : emailNotifRaw === true || emailNotifRaw === "true";

        setEmailNotificationsEnabled(emailNotif);
    }, [user]);

    /* ================= Notifications ================= */
    const [notificationsEnabled, setNotificationsEnabled] = useState<boolean>(false);
    // const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState<boolean>(false);

    useEffect(() => {
        fetchNotifications();
    }, [user]);

    const fetchNotifications = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/notifications?user_id=${user.getUid()}`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const data = await response.json();
            const soundNotifRaw = data["Sound Notifications"];
            const soundNotifBool = soundNotifRaw === true || soundNotifRaw === "true";

            localStorage.setItem(
                `chat_notifications_${user.getUid()}`,
                JSON.stringify(soundNotifBool)
            );

            setNotificationsEnabled(Boolean(soundNotifBool));

            // const emailNotifRaw = data["Email Notifications"];
            // console.log("Email Notifications API response:", emailNotifRaw);
            // const emailNotifBool = emailNotifRaw === true || emailNotifRaw === "true";

            // localStorage.setItem(
            //     `chat_email_notifications_${user.getUid()}`,
            //     JSON.stringify(emailNotifBool)
            // );

            // setEmailNotificationsEnabled(Boolean(emailNotifBool));

        } catch (error) {
            console.error("Failed to fetch notification:", error);
            setNotificationsEnabled(false);
        }
    };

    const updateNotification = async (value: boolean) => {
        try {
            const response = await fetch(`${API_BASE_URL}/notifications/update`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: user.getUid(),
                    sound_notifications: value
                }),
            });

            if (!response.ok) throw new Error(`Failed to update: ${response.status}`);

            await fetchNotifications();

        } catch (error) {
            console.error("Error updating notification:", error);
            alert("Failed to update notification");
        }
    };

    const updateEmailNotification = async (value: boolean) => {
        try {
            const response = await fetch(`${API_BASE_URL}/notifications/updateEmail`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: user.getUid(),
                    email_notifications: value
                }),
            });

            if (!response.ok) throw new Error(`Failed to update: ${response.status}`);

            // Optional: refresh from backend
            await fetchNotifications();

        } catch (error) {
            console.error("Error updating email notification:", error);
            alert("Failed to update email notification");
        }
    };

    /* ================= Friends ================= */
    useEffect(() => {
        const fetchFriends = async () => {
            try {
                const res = await fetch(
                    `${COMETCHAT_CONSTANTS.API_URL}/users/${user.getUid()}/friends?perPage=100&page=1`,
                    {
                        headers: {
                            'apikey': COMETCHAT_CONSTANTS.REST_API_KEY,
                        },
                    }
                );
                const data = await res.json();

                const friends: Friend[] = data.data.map((f: any) => ({
                    uid: f.uid,
                    name: f.name,
                    avatar: f.avatar
                        ? f.avatar.replace(/\\/g, '')
                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(f.name)}`,
                    status: f.status,
                    role: f.role,
                    lastActiveAt: f.lastActiveAt
                }));

                setFriendsList(friends);
            } catch (err) {
                console.error('Failed to fetch friends', err);
            }
        };
        fetchFriends();
    }, [user]);

    /* ================= Avatar Upload ================= */
    const uploadAvatarToImgBB = async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('image', file);

        const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
            method: 'POST',
            body: formData,
        });

        const data = await response.json();
        if (!data.success) throw new Error(data.error?.message || 'Upload failed');
        return data.data.url;
    };

    const onAvatarChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
            alert('Image must be smaller than 2MB');
            return;
        }

        try {
            setUploading(true);
            const imageUrl = await uploadAvatarToImgBB(file);
            setAvatar(imageUrl);
        } catch (err) {
            console.error('Avatar upload failed', err);
            alert('Failed to upload image');
        } finally {
            setUploading(false);
        }
    };

    /* ================= Save ================= */
    const handleSave = async () => {
        try {
            user.setName(name);
            user.setAvatar(avatar);

            const updatedUser = await CometChat.updateCurrentUserDetails(user);
            onUpdated(updatedUser);
            onClose();
        } catch (err) {
            console.error('Profile update failed', err);
            alert('Failed to update profile');
        }
    };


    const handleEmailToggle = async (value: boolean) => {
        try {
            const metadata = (user.getMetadata() || {}) as UserMetadata;
            const privateMeta = metadata['@private'] || {};

            const updatedMetadata: UserMetadata = {
                ...metadata,
                '@private': {
                    ...privateMeta,
                    email_notifications: value
                }
            };

            user.setMetadata(updatedMetadata);

            const updatedUser = await CometChat.updateCurrentUserDetails(user);

            // optional: update UI
            onUpdated(updatedUser);

        } catch (err) {
            console.error('Toggle update failed', err);
        }
    };

    // const handleSave = async () => {
    //     try {
    //         user.setName(name);
    //         user.setAvatar(avatar);
    //         const metadata = (user.getMetadata() || {}) as UserMetadata;

    //         const privateMeta = metadata['@private'] || {};

    //         const updatedMetadata: UserMetadata = {
    //             ...metadata,
    //             '@private': {
    //                 ...privateMeta,
    //                 email_notifications: emailNotificationsEnabled ?? true // ✅ fallback
    //             }
    //         };

    //         user.setMetadata(updatedMetadata);

    //         const updatedUser = await CometChat.updateCurrentUserDetails(user);

    //         onUpdated(updatedUser);
    //         onClose();
    //     } catch (err) {
    //         console.error('Profile update failed', err);
    //         alert('Failed to update profile');
    //     }
    // };

    /* ================= Theme Change ================= */
    const handleThemeChange = (newTheme: 'light' | 'dark' | 'system') => {
        setStyleFeatures(prev => ({ ...prev, theme: newTheme }));
        localStorage.setItem(`chat_theme_${user.getUid()}`, newTheme);
    };

    return (
        <div className="profile-overlay">
            <div className="profile-modal">

                {/* Header */}
                <div className="profile-header">
                    <ArrowLeft size={24} onClick={onClose} className="back-icon" />
                    <h3>Profile</h3>
                </div>

                {/* Profile */}
                <div className="profile-main">
                    <div className="avatar-wrapper">
                        <img
                            className="avatar-img"
                            src={avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}`}
                            alt="avatar"
                        />
                        <div className="avatar-edit" onClick={() => document.getElementById('avatar-upload')?.click()}>
                            {uploading ? 'Uploading...' : <Camera size={20} />}
                        </div>
                        <input type="file" hidden id="avatar-upload" onChange={onAvatarChange} />
                    </div>

                    <input
                        className="profile-name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />

                    <div className="profile-role-lastActive">
                        <div><strong>Role:</strong> {user.getRole().toLowerCase() === "manager"
                            ? "RA"
                            : user.getRole().charAt(0).toUpperCase() + user.getRole().slice(1)}</div>

                        <div><strong>Email:</strong> {(user.getMetadata() as UserMetadata)?.['@private']?.email}</div>

                        <div>
                            <strong>Last Active:</strong>{' '}
                            {user.getLastActiveAt() > 0
                                ? new Date(user.getLastActiveAt() * 1000).toLocaleString()
                                : 'You have logged in for the first time'}
                        </div>
                    </div>

                    <button className="profile-save-btn" onClick={handleSave} disabled={uploading}>
                        Save
                    </button>
                </div>

                {/* Friends List below */}
                {user.getRole() !== "manager" && user.getRole() !== "lc" && <div className="friends-section">
                    <h3>{"RA Assign"}</h3>
                    {friendsList.length === 0 ? (
                        <p className="no-friends-text">{user.getRole() === "manager" ? "No contacts found." : "No manager assigned"}</p>
                    ) : (
                        <ul className="friends-list">
                            {friendsList.map(f => (
                                <li key={f.uid} className="friend-item">
                                    <img src={f.avatar} alt={f.name} className="friend-avatar" />
                                    <span className="friend-name">{f.name}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>}

                {/* Notifications */}
                <div className="wa-toggle-container">
                    <span className="wa-toggle-label">Sound Notifications</span>
                    <label className="wa-switch">
                        <input
                            type="checkbox"
                            checked={notificationsEnabled}
                            // onChange={async (e) => {
                            //     const value = e.target.checked;
                            //     setNotificationsEnabled(value);
                            //     localStorage.setItem(
                            //         `chat_notifications_${user.getUid()}`,
                            //         JSON.stringify(value)
                            //     );
                            //     await updateNotification(value);
                            // }}
                            onChange={async (e) => {
                                const value = e.target.checked;

                                setNotificationsEnabled(value);

                                localStorage.setItem(
                                    `chat_notifications_${user.getUid()}`,
                                    JSON.stringify(value)
                                );

                                // Immediate effect
                                overrideAudio(!value);

                                await updateNotification(value);
                            }}
                        />
                        <span className="wa-slider"></span>
                    </label>
                </div>

                {/* Email Notifications */}
                <div className="wa-toggle-container">
                    <span className="wa-toggle-label">Email Notifications</span>
                    <label className="wa-switch">
                        <input
                            type="checkbox"
                            checked={emailNotificationsEnabled}
                            onChange={async (e) => {
                                const value = e.target.checked;
                                setEmailNotificationsEnabled(value); // UI update
                                handleEmailToggle(value);            // 🔥 instant API call
                                try {
                                    await updateEmailNotification(value);
                                } catch (error) {
                                    setEmailNotificationsEnabled(!value);
                                    console.error("Failed to update email notifications:", error);
                                }
                            }}
                        />
                        <span className="wa-slider"></span>
                    </label>
                </div>

                {/* <div className="wa-toggle-container">
                    <span className="wa-toggle-label">Email Notifications</span>
                    <label className="wa-switch">
                        <input
                            type="checkbox"
                            checked={emailNotificationsEnabled}
                            onChange={async (e) => {
                                const value = e.target.checked;

                                setEmailNotificationsEnabled(value);

                                localStorage.setItem(
                                    `chat_email_notifications_${user.getUid()}`,
                                    JSON.stringify(value)
                                );

                                await updateEmailNotification(value);
                            }}
                        />
                        <span className="wa-slider"></span>
                    </label>
                </div> */}

                {/* 🎯 Theme Selector (ChatGPT Style) */}
                <div className="wa-toggle-container">
                    <span>Theme</span>

                    <div className="theme-selector">
                        <button
                            className={styleFeatures?.theme === 'system' ? 'active' : ''}
                            onClick={() => handleThemeChange('system')}
                        >
                            💻 System
                        </button>

                        <button
                            className={styleFeatures?.theme === 'light' ? 'active' : ''}
                            onClick={() => handleThemeChange('light')}
                        >
                            ☀️ Light
                        </button>

                        <button
                            className={styleFeatures?.theme === 'dark' ? 'active' : ''}
                            onClick={() => handleThemeChange('dark')}
                        >
                            🌙 Dark
                        </button>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default CometChatUserProfileModal;